export * from './skill-matrix-add.component';
